/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_State_Checked_InInputs */



/**
* | output |
* | --- |
* | "Checked in" |
*
* @param {Player_State_Checked_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_state_checked_in = /** @type {((inputs?: Player_State_Checked_InInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_State_Checked_InInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Con check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Com check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check-in fatto")
	return /** @type {LocalizedString} */ ("Checked in")
});